/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_AddInputs */

const cs_parties_add = /** @type {(inputs: Parties_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat stranu`)
};

const en_parties_add = /** @type {(inputs: Parties_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add party`)
};

/**
* | output |
* | --- |
* | "Add party" |
*
* @param {Parties_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_add = /** @type {((inputs?: Parties_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_add(inputs)
	return cs_parties_add(inputs)
});